export { ErrorBoundary, default } from "./routes/search/main.tsx";